import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_REQUEST_DETAIL = 'GET_REQUEST_DETAIL';
export const GET_REQUEST_DETAIL_SUCCESS = 'GET_REQUEST_DETAIL_SUCCESS';
export const GET_REQUEST_DETAIL_FAILURE = 'GET_REQUEST_DETAIL_FAILURE';

// Action Creators
export const getRequestDetail = () => ({
  type: GET_REQUEST_DETAIL,
});

export const getRequestDetailSuccess = (users) => ({
  type: GET_REQUEST_DETAIL_SUCCESS,
  payload: users,
});

export const getRequestDetailFailure = (error) => ({
  type: GET_REQUEST_DETAIL_FAILURE,
  payload: error,
});

// Thunk Function
export const getRequestDetailData = (external, id) => {
  return async (dispatch) => {
    dispatch(getRequestDetail());
    try {
      const response = await getMethodWithToken(url?.requestDetail + id + '/');
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getRequestDetailSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(getRequestDetailFailure('error?.message'));
      }
    } catch (error) {
      dispatch(getRequestDetailFailure(error?.message));
    }
  };
};
